import type { CmsApiPagePost } from '#/modules/cms/api/types/CmsApiPage';
import { useReloadIfFreeCodeBlockAndClientNavigation } from '#/modules/cms/hooks/useReloadIfFreeCodeBlockAndClientNavigation';
import { useCmsPageRevalidateAfterUserAuthentication } from '#/modules/cms/pages/splat/cmsSplatRouteRevalidation';
import { LazyNotFoundPage } from '#/pages/NotFound/LazyNotFoundPage';

import { CmsPostPageBody } from './Body/CmsPostPageBody';
import { CmsPostPageLayout } from './Layout/CmsPostPageLayout';

type Props = {
  content: CmsApiPagePost;
};

export function CmsPostPage({ content }: Props) {
  useCmsPageRevalidateAfterUserAuthentication();

  const { showPageNotFound } =
    useReloadIfFreeCodeBlockAndClientNavigation(content);
  if (showPageNotFound) return <LazyNotFoundPage />;

  return (
    <CmsPostPageLayout content={content}>
      <CmsPostPageBody content={content} />
    </CmsPostPageLayout>
  );
}
